import { Modal } from '#molecules';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useState } from 'react';
import { PortfolioListModal } from '#molecules/PortfolioListModal';
import { Text } from '#atoms';
import {
  CertificationTag,
  Container,
  FilterBox,
  FilterItem,
  ImgBox,
  MiddleWrap,
  PointText,
  PortfolioCard,
  PortfolioInfo,
  PostingBox
} from './styles';

import CertificationMark from '#assets/svg/CertificationMark.svg';
import { PortfolioListUpdate } from '#organisims/PortfolioListUpdate';
interface FileDto {
  id: string;
  resizedLink: string; // 리사이즈된 파일 링크
  shortLink?: string; // 단축된 파일 링크
  uploadedLink: string; // 업로드된 파일 링크
}
export interface dummyDataType {
  isCertification: boolean;
  img: FileDto;
  memberName: string;
  title: string;
  id: string;
  index: number;
}

const dummyDataPost: dummyDataType[] = [
  {
    isCertification: true,
    img: { id: '', resizedLink: '', uploadedLink: '' },
    memberName: '최강록',
    title: '20대 마지막을 바디프로필 촬영으로 마무리하다',
    id: '',
    index: 0
  },
  {
    isCertification: false,
    img: { id: '', resizedLink: '', uploadedLink: '' },
    memberName: '이원일',
    title: '8주간의 여름맞이 다이어트',
    id: '',
    index: 1
  },
  {
    isCertification: true,
    img: { id: '', resizedLink: '', uploadedLink: '' },
    memberName: '최현석',
    title: '초고도비만에서 표준으로',
    id: '',
    index: 2
  }
];

const dummyDataHide: dummyDataType[] = [
  {
    isCertification: true,
    img: { id: '', resizedLink: '', uploadedLink: '' },
    memberName: '백종원',
    title: '발목 부상 재활운동 트레이닝',
    id: '',
    index: 0
  },
  {
    isCertification: false,
    img: { id: '', resizedLink: '', uploadedLink: '' },
    memberName: '에드워드리',
    title: '다이어트만 n번째 회원님의 마지막 도전 이야기',
    id: '',
    index: 1
  },
  {
    isCertification: true,
    img: { id: '', resizedLink: '', uploadedLink: '' },
    memberName: '안성재',
    title: '인생의 마지막이라는 생각으로',
    id: '',
    index: 2
  }
];

export const PortfolioList = () => {
  const [isModal, setIsModal] = useState(false);

  const [postData, setPostData] = useState(dummyDataPost);
  const [hideData, setHideData] = useState(dummyDataHide);
  const [isUpDate, setIsUpdate] = useState(false);
  const hideMemberName = (name: string) => {
    const hideName = name[0] + '*'.repeat(name.length - 1);
    return hideName;
  };

  const onClose = () => {
    setIsUpdate(false);
  };

  const onClickUpdateList = (
    postList: dummyDataType[],
    hideList: dummyDataType[]
  ) => {
    setPostData(postList);
    setHideData(hideList);
    onClose();
  };
  return (
    <>
      {!isUpDate && (
        <PrevHeaderBarWithTitleTemplate
          title="트레이닝 성과"
          defaultBackground
          headerbarStyle={{ color: '#C9C7D1' }}
          rightContents={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              onClick={() => setIsModal(true)}
            >
              <rect fill="#7750E9" width="24" height="24" rx="12" ry="12" />
              <path
                d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z"
                fill="#EAE8ED"
              />
            </svg>
          }
        >
          <Container>
            <MiddleWrap>
              <Text style={{ color: '#8e899f' }}>
                게시중 <PointText>{postData.length}</PointText>
              </Text>
              <FilterBox>
                <FilterItem onClick={() => setIsUpdate(true)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M8 4L5.33333 1.33333L2.66667 4L4.66667 4L4.66667 14L6 14L6 4L8 4Z"
                      fill="#8E899F"
                    />
                    <path
                      d="M8 12L10.6667 14.6667L13.3333 12L11.3333 12L11.3333 2L10 2L10 12L8 12Z"
                      fill="#8E899F"
                    />
                  </svg>
                  <Text style={{ fontSize: '1.3rem', lineHeight: '1.8rem' }}>
                    편집
                  </Text>
                </FilterItem>
              </FilterBox>
            </MiddleWrap>
            <PostingBox>
              {postData.map(post => (
                <PortfolioCard>
                  <ImgBox>
                    <img src={post.img.resizedLink} />
                  </ImgBox>
                  <PortfolioInfo>
                    {post.isCertification && (
                      <CertificationTag>
                        <img src={CertificationMark} />
                        운동차트 인증
                      </CertificationTag>
                    )}
                    <Text style={{ fontSize: '1.6rem' }}>{post.title}</Text>
                    <Text textStyle="c2" style={{ color: '#8e899f' }}>
                      {hideMemberName(post.memberName)} 회원님
                    </Text>
                  </PortfolioInfo>
                </PortfolioCard>
              ))}
            </PostingBox>
            <Text style={{ marginTop: '4.8rem', color: '#8e899f' }}>
              숨긴 트레이닝 성과 <PointText>{hideData.length}</PointText>
            </Text>
            <PostingBox>
              {hideData.map(post => (
                <PortfolioCard>
                  <ImgBox>
                    <img src={post.img.resizedLink} />
                  </ImgBox>
                  <PortfolioInfo>
                    {post.isCertification && (
                      <CertificationTag>
                        <img src={CertificationMark} />
                        운동차트 인증
                      </CertificationTag>
                    )}
                    <Text style={{ fontSize: '1.6rem' }}>{post.title}</Text>
                    <Text textStyle="c2" style={{ color: '#8e899f' }}>
                      {hideMemberName(post.memberName)} 회원님
                    </Text>
                  </PortfolioInfo>
                </PortfolioCard>
              ))}
            </PostingBox>
          </Container>

          {isModal && (
            <Modal onClose={() => setIsModal(false)}>
              <PortfolioListModal onClose={() => setIsModal(false)} />
            </Modal>
          )}
        </PrevHeaderBarWithTitleTemplate>
      )}
      {isUpDate && (
        <PortfolioListUpdate
          postData={postData}
          hideData={hideData}
          onClose={onClose}
          onClickUpdateList={onClickUpdateList}
        />
      )}
    </>
  );
};
